/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ThresholdConfig } from './ThresholdConfig';
import {
    ThresholdConfigFromJSON,
    ThresholdConfigFromJSONTyped,
    ThresholdConfigToJSON,
    ThresholdConfigToJSONTyped,
} from './ThresholdConfig';

/**
 * 
 * @export
 * @interface FormSectionResponse
 */
export interface FormSectionResponse {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    sectionSnapshotId?: string;
    /**
     * 
     */
    question?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    sectionType?: FormSectionResponseSectionTypeEnum;
    /**
     * 
     */
    index?: number;
    /**
     * 
     */
    guidanceImageUrl?: string;
    /**
     * 
     */
    areaId?: string;
    /**
     * 
     */
    areaName?: string;
    /**
     * 
     */
    machinePartId?: string;
    /**
     * 
     */
    measurementKey?: string;
    /**
     * 
     */
    thresholds?: ThresholdConfig;
    /**
     * 
     */
    sectionId?: string;
    /**
     * 
     */
    sectionTitle?: string;
}


/**
 * @export
 */
export const FormSectionResponseSectionTypeEnum = {
    StatusCheck: 'STATUS_CHECK',
    NumberEntry: 'NUMBER_ENTRY',
    TextResult: 'TEXT_RESULT',
    MultiValue: 'MULTI_VALUE',
} as const;
export type FormSectionResponseSectionTypeEnum = typeof FormSectionResponseSectionTypeEnum[keyof typeof FormSectionResponseSectionTypeEnum];


/**
 * Check if a given object implements the FormSectionResponse interface.
 */
export function instanceOfFormSectionResponse(value: object): value is FormSectionResponse {
    return true;
}

export function FormSectionResponseFromJSON(json: any): FormSectionResponse {
    return FormSectionResponseFromJSONTyped(json, false);
}

export function FormSectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormSectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sectionSnapshotId': json['sectionSnapshotId'] == null ? undefined : json['sectionSnapshotId'],
        'question': json['question'] == null ? undefined : json['question'],
        'description': json['description'] == null ? undefined : json['description'],
        'sectionType': json['sectionType'] == null ? undefined : json['sectionType'],
        'index': json['index'] == null ? undefined : json['index'],
        'guidanceImageUrl': json['guidanceImageUrl'] == null ? undefined : json['guidanceImageUrl'],
        'areaId': json['areaId'] == null ? undefined : json['areaId'],
        'areaName': json['areaName'] == null ? undefined : json['areaName'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'measurementKey': json['measurementKey'] == null ? undefined : json['measurementKey'],
        'thresholds': json['thresholds'] == null ? undefined : ThresholdConfigFromJSON(json['thresholds']),
        'sectionId': json['sectionId'] == null ? undefined : json['sectionId'],
        'sectionTitle': json['sectionTitle'] == null ? undefined : json['sectionTitle'],
    };
}

export function FormSectionResponseToJSON(json: any): FormSectionResponse {
    return FormSectionResponseToJSONTyped(json, false);
}

export function FormSectionResponseToJSONTyped(value?: FormSectionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sectionSnapshotId': value['sectionSnapshotId'],
        'question': value['question'],
        'description': value['description'],
        'sectionType': value['sectionType'],
        'index': value['index'],
        'guidanceImageUrl': value['guidanceImageUrl'],
        'areaId': value['areaId'],
        'areaName': value['areaName'],
        'machinePartId': value['machinePartId'],
        'measurementKey': value['measurementKey'],
        'thresholds': ThresholdConfigToJSON(value['thresholds']),
        'sectionId': value['sectionId'],
        'sectionTitle': value['sectionTitle'],
    };
}

